"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
exports.Container = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 8px;\n  opacity: ", ";\n  pointer-events: ", ";\n  position: relative;\n  width: ", ";\n"], ["\n  margin-bottom: 8px;\n  opacity: ", ";\n  pointer-events: ", ";\n  position: relative;\n  width: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled ? '.2' : '1';
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? 'none' : 'default';
}, function (_a) {
    var width = _a.width;
    return width ? width : '100%';
});
var templateObject_1;
//# sourceMappingURL=Container.js.map